import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89646660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ringingCallContainer" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "calling" }
const _hoisted_7 = { class: "right" }

import { UsersGetterTypes } from "@/store/users";
import { User } from "@/store/users/state";
import { computed } from "vue";
import { useStore } from "vuex";
import RingingCallIcon from "../RingingCallIcon/RingingCallIcon.vue";
import { ActionButtonType } from "@/types/button";
import { ActionTypes } from "@/store";

interface Props {
  chatId: string;
  callerId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RingingCallBanner',
  props: {
    chatId: {},
    callerId: {}
  },
  setup(__props: any) {

const props = __props;
const { getters, dispatch } = useStore();
const user = computed<User>(() =>
  getters[UsersGetterTypes.GET_USER](props.callerId),
);

const acceptCall = () => {
  dispatch(ActionTypes.ACCEPT_RINGING_CALL, props.chatId);
};

const declineCall = () => {
  dispatch(ActionTypes.DECLINE_RINGING_CALL, props.chatId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: user.value.picture,
        alt: "profile picture",
        class: "profilePicture"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(user.value.name), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("call.isCallingYou")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(RingingCallIcon, {
        "action-type": _unref(ActionButtonType).Accept,
        onClick: acceptCall
      }, null, 8, ["action-type"]),
      _createVNode(RingingCallIcon, {
        "action-type": _unref(ActionButtonType).Decline,
        onClick: declineCall
      }, null, 8, ["action-type"])
    ])
  ]))
}
}

})